import styled from 'styled-components';
import { IThemeProvider } from '../../../../../../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const Row = styled.div`
  position: relative;
  width: 100%;
  height: 16px;
  border-radius: 4px;
  margin-right: 40px;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.secondary};
  `}
`;

export const InnerRow = styled.div``;
